module.exports = {
    // index/default
    "BobTV, webcam chat for adults of Bob Voyeur": "BobTV, le tchat webcam pour adultes de Bob Voyeur",
    "Videochat rooms to exhibit on webcam for amateur libertines and voyeurs. Nudity and sex webcams are accepted on chat rooms.":
        "Salles de visiochat pour exhib en cam entre amateurs libertins ou voyeurs. La nudité et les rapports sexuels en cam sont acceptés sur les salons de tchat.",

    // profile
    "%1, %2, %3, voyeur or exhibitionist on BobTV adult webcam chat": "%1, %2, %3, voyeur ou exhib sur BobTV le tchat webcam pour adultes.",
    "Member on adult video chat Bob TV." : "Membre sur le visiochat pour adultes de bob TV.",

    // profiles
    'List of members of the chat of exhib on cam': "Liste des membres du tchat d'exhib en cam",
    'results for searching of members - BobTV': "résultats de recherche des membres - BobTV",
    'Search among BobTV members, exhibitionists, voyeurs, libertines or swingers.': "Recherche parmi les membres de BobTV, exhibitionnistes, voyeurs, libertins ou échangistes.",

    // profile films
    'Amateur films of %1': "Les films amateurs de %1",

    // profile photos
    'Photos of %1': "Les photos de %1",

    // profile wall
    'Wall posts of %1': "Le mur de %1",
    'The wall of BobTV, photos and videos posted by %1': "Le Mur de BobTV, les photos et les vidéos postées par %1",

    // faq
    'Frequently Asked Questions (FAQ)': "La FAQ de BobTV",
    'Help page to connect to BobTV Webcam Chat. Visio Chat of exhibitions and meetings between adults.': "Page d'aide pour vous connecter au Webcam Tchat de BobTV. Visio Tchat d'exhibitions et de rencontres entre adultes.",

    // amateur films
    'Amateur videos of bobbesies and bobbers': 'Les vidéos amateurs des bobeuses et bobeurs',
    'Amateur videos by tag: %1': 'Liste des vidéos pour le mot-clé : %1',

    // wall
    'The wall  of BobTV, photos and videos posted by members': 'Le Mur de BobTV, les photos et les vidéos postées par les membres',

    // wardrobe
    'Bobstore Wardrobe': 'Le dressing de Bobstore',
    
    // wishlists
    "Wishlists of BobTV members. Naughty and erotic gifts.": "Les listes d'envies des membres de BobTV. Cadeaux coquins et érotiques.",

    // contact
    'Contact BobTV page': 'Page Contact de BobTV - Chat webcam libertin et amateur - Support technique du tchat video - Informations sur le site de rencontres visio.',
    'Contact Bob for all matters relating to the webcam chat BobTV. Video Chat exhibitions and meetings between adults.': "Contacter Bob pour toutes demandes concernant votre compte gratuit sur le Premier Tchat Webcam libertin. Aide et support en ligne pour accéder aux annonces de rencontres et au viso chat. BobTV est le plus grand site de l'exhibition en cam pour des milliers d'amateurs et de couples pratiquant l'échangisme.",

    // auth pages
    'Login to bobTV': 'Connexion à bobTV',
    'Registration at BobTV' : 'Inscription sur BobTV',
    'bobTV Webcam Chat free registration. Video Chat exhibitions and meetings between adults.' : 'Créez votre compte gratuit sur le Premier Tchat Webcam libertin. Rencontre, exhibition en cam pour des milliers d\'amateurs et de couples pratiquant l\'échangisme.'
};


// WEBPACK FOOTER //
// ./src/l10n-messages/fr/meta.js